<template>
  <div class="table-responsive">
    <table class="table-v3 no-wrap" role="table">
      <thead>
        <tr>
          <th class="nowrap">
            <span class="fancy-checkbox font-14 ml-2">
              <input
                type="checkbox"
                id="select-all-boletos"
                title="Selecionar todos desta página"
                @change="toggleSelectAll"
                v-model="selectAll"
              />
            </span>
          </th>
          <th>SEGURADORA</th>
          <th>Nro. Apólice</th>
          <th>INTERESSADOS</th>
          <th>CNPJ TOMADOR</th>
          <th>MODALIDADE</th>
          <th>VALORES</th>
          <th>VIGÊNCIA</th>
          <th class="text-center">DATAS</th>
          <th class="text-center">STATUS</th>
          <th class="text-center">AÇÕES</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, idx) in items"
          :key="idx"
          role="row"
          style="--small-badge-width:5ch"
        >
          <td>
            <span
              class="fancy-checkbox font-14 ml-2"
              :style="{ color: item.status==='PAGO' ? 'rgb(191,192,192)' : '' }"
            >
              <input
                type="checkbox"
                class="checkbox-batch-item"
                :checked="isBilletSelected(item)"
                :disabled="item.status==='PAGO'"
                @change="toggleBilletSelection(item)"
              />
            </span>
          </td>
          <td>
            <img
              :src="item.icon_insurer"
              alt="Logo"
              class="logo-seguradora"
            />
          </td>
          <td class="text-truncate">{{ item.number }}</td>
          <td style="--small-badge-width:3ch">
            <div class="d-flex flex-column">
              <span
                class="d-flex align-items-center text-truncate"
                style="max-width:150px"
                :title="item.policy_holder_name"
              >
                <span
                  class="badge badge-secondary mr-1"
                  style="width:var(--small-badge-width)"
                  title="Tomador"
                  v-b-tooltip.hover
                >
                  T
                </span>
                {{ item.policy_holder_name }}
              </span>
              <span
                class="d-flex align-items-center text-truncate"
                style="max-width:150px"
                :title="item.insured_name"
              >
                <span
                  class="badge badge-secondary mr-1"
                  style="width:var(--small-badge-width)"
                  title="Segurado"
                  v-b-tooltip.hover
                >
                  S
                </span>
                {{ item.insured_name }}
              </span>
            </div>
          </td>
          <td class="text-truncate">{{ item.policy_holder_document | formatDocument }}</td>
          <td>
            <span class="truncate-100 truncate-xxl-150 text-truncate">
              {{ item.insurance_type_id }}
            </span>
          </td>
          <td>
            <div class="d-flex flex-column">
              <span>
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Importância Segurada"
                  v-b-tooltip.hover
                >
                  I.S
                </span>
                {{ formatCurrency(item.coverage_value) }}
              </span>
              <span>
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Prêmio"
                  v-b-tooltip.hover
                >
                  PR
                </span>
                {{ formatCurrency(item.insurance_premium) }}
              </span>
            </div>
          </td>
          <td>
            <div class="d-flex flex-column">
              <span>
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Início da Vigência"
                >
                  DE
                </span>
                {{ item.validity_start }}
              </span>
              <span>
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Término da Vigência"
                >
                  ATÉ
                </span>
                {{ item.validity_expiration }}
              </span>
            </div>
          </td>
          <td>
            <div class="d-flex flex-column">
              <span>
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Vencimento"
                  v-b-tooltip.hover
                >
                  V
                </span>
                {{ item.end_date }}
              </span>
              <span v-if="item.extended_date !== '-'">
                <span
                  class="badge badge-secondary"
                  style="width:var(--small-badge-width)"
                  title="Prorrogado para"
                  v-b-tooltip.hover
                >
                  P
                </span>
                {{ item.extended_date }}
              </span>
            </div>
          </td>
          <td>
            <span
              class="btn btn-sm text-uppercase rounded-pill d-block"
              :style="{
                backgroundColor: getStatusBadgeColor(checkStatus(item)),
                color: 'white',
                minWidth: '120px',
                margin: '0'
              }"
            >
              {{ checkStatus(item) }}
            </span>
          </td>
          <td class="text-center actions">
            <div class="btn-group">
              <button
                class="btn btn-action"
                v-b-tooltip.hover title="Visualizar boleto"
                @click="getBillet(item)"
              >
                <i class="fa fa-paperclip"></i>
              </button>
              <button v-if="isMaster() && item.status !== 'PAGO'" class="btn btn-action" @click="openModalProrrogar(item)">
                  <i class="far fa-calendar-plus" v-b-tooltip.hover title="Prorrogar o boleto"></i>
              </button>
              <button
                v-if="item.status!=='PAGO'"
                class="btn btn-action"
                v-b-tooltip.hover title="Confirmar pagamento"
                @click="markBilletAsPaid(item)"
              >
                <i class="fa fa-toggle-on fa-flip-horizontal"></i>
              </button>
              <button
                v-else
                class="btn btn-action"
                v-b-tooltip.hover title="Pagamento confirmado"
              >
                <i class="fa fa-toggle-on text-primary"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div>
      <b-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        class="my-3 mb-4"
      />
    </div>
    <b-modal ref="modalProrrogar" id="modal-prorrogar" size="lg" class="mt-4" centered>
      <template #modal-title>
        Prorrogar Boleto
      </template>

      <form style="padding-inline: 1.5rem">
        <div class="row">
          <div class="col-12 mb-3">
            <div class="form-subheader"><span>Dados Gerais</span></div>
          </div>
          <div class="col-12 col-lg-3 mb-3">
            <img :src="selectedBillet?.icon_insurer" class="modal-insurance-logo" style="max-height: 60px;">
          </div>
          <div class="col-12 col-lg-3 mb-3">
            <label class="dbo-ui">Nro. Apólice</label>
            <p>{{ selectedBillet?.number }}</p>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label class="dbo-ui">Modalidade de Seguro</label>
            <p>{{ selectedBillet?.insurance_type_id }}</p>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label class="dbo-ui">Tomador</label>
            <p>{{ selectedBillet?.policy_holder_name }}</p>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label class="dbo-ui">Segurado</label>
            <p>{{ selectedBillet?.insured_name }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <div class="form-subheader"><span>Valores</span></div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label class="dbo-ui">Importância Segurada</label>
            <p>{{ formatCurrency(selectedBillet?.coverage_value) }}</p>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label class="dbo-ui">Prêmio</label>
            <p>{{ formatCurrency(selectedBillet?.insurance_premium) }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-6">
            <label class="dbo-ui">Data de vencimento atual</label>
            <p class="form-control-plaintext"><strong>{{ selectedBillet?.extended_date && selectedBillet?.extended_date
              != '-'
              ?
              selectedBillet?.extended_date :
              selectedBillet?.end_date }}</strong></p>
          </div>
          <div class="col-12 col-lg-6">
            <label class="dbo-ui">Digite a nova data de vencimento do boleto</label>
            <input v-model="newDate" type="date" required="required" list="policyHolderList"
              class="mb-3 form-control form-control-lg">
          </div>
        </div>
      </form>

      <template #modal-footer>
        <b-button @click="changeDate(selectedBillet?.id)" variant="primary">Prorrogar</b-button>
      </template>
    </b-modal>

  </div>
</template>


<script>
import billetService from "@/services/billet";
import dateFormatter from "@/mixins/dateFormatter";
import numericFormatterMixin from "@/mixins/numericFormatter";
import authenticationService from "@/services/authentication";

export default {
  name: "DatatableBoletos",
  mixins: [dateFormatter, numericFormatterMixin],
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      items: [],
      currentPage: 1,
      newDate: null,
      perPage: 10,
      totalItems: 0,
      lastPage: 1,
      msgLoading: "Carregando boletos...",
      loading: false,
      selectedBillet: null,
      selectAll: false
    };
  },
  watch: {
    currentPage() {
      this.fetchBillets(this.filters);
    },
  },
  created() {
    this.fetchBillets();
  },
  methods: {
    markBilletAsPaid(item) {
      if (item.status !== 'PAGO') {
        this.$emit('open-single-billet-modal', item);
      }
    },
    getBillet(item) {
      this.loading = true;

      billetService.getBillet(item.id)
        .then((response) => {
          // Tentar obter billing_file via quotation primeiro, depois diretamente da policy
          const billingFile = response.data.quotation?.policy?.billing_file || response.data.policy?.billing_file;
          if (billingFile) {
            this.openLinkTargetBlank(billingFile);
          } else {
            this.showError("Arquivo de cobrança não encontrado.");
          }
        })
        .catch(() => {
          this.showError("Não foi possível acessar o boleto.");
        }).finally(() => {
          this.loading = false;
        });
    },
    getStatusBadgeClass(status) {
      switch (status) {
        case 'PAGO':
          return 'status-badge-billet-green';
        case 'EM ABERTO':
          return 'status-badge-billet-yellow';
        case 'VENCIDO':
          return 'status-badge-billet-red';
        default:
          return 'status-badge-billet-default';
      }
    },
    getStatusBadgeColor(status) {
      switch (status) {
        case 'PAGO':
          return '#20c997';
        case 'EM ABERTO':
          return '#ffb635';
        case 'VENCIDO':
          return 'crimson';
        default:
          return '#6c757d';
      }
    },
    fetchBillets(filters = {}) {
      this.loading = true;
      billetService.get({ page: this.currentPage, per_page: this.perPage, ...filters }).then(response => {
        this.formatList(response.data.data);
        this.totalItems = response.data.total;
        this.lastPage = response.data.last_page;
      }).catch(() => {
        this.showError("Não foi possível recuperar os boletos.");
      }).finally(() => {
        this.loading = false;
      });
    },
    isMaster(){
      return authenticationService.isMaster()
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.items.forEach(billet => {
          if (billet.status !== 'PAGO' && !this.isBilletSelected(billet)) {
            this.$emit('toggle-billet-selection', billet);
          }
        });
      } else {
        this.items.forEach(billet => {
          if (this.isBilletSelected(billet)) {
            this.$emit('toggle-billet-selection', billet);
          }
        });
      }
    },
    toggleBilletSelection(billet) {
      if (billet.status !== 'PAGO') {
        this.$emit('toggle-billet-selection', billet);
      }
    },
    isBilletSelected(billet) {
      return this.$parent.selectedBillets.some(b => b.id === billet.id);
    },
    applyFiltersToBillets(filters) {
      this.fetchBillets(filters);
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    checkStatus(item) {
      if (item.status === 'PAGO') return item.status;

      const today = this.parseDate(new Date().toLocaleDateString('pt-BR'));
      const dateToCheck = item.extended_date && item.extended_date !== '-'
        ? this.parseDate(item.extended_date)
        : this.parseDate(item.end_date);

      return dateToCheck < today ? 'VENCIDO' : item.status;
    },

    parseDate(dateStr) {
      const [day, month, year] = dateStr.split('/');
      return new Date(`${year}-${month}-${day}`);
    },
    formatList(data) {
      const mappedItems = data.map((element) => {
        // Tentar obter policy via quotation primeiro, depois diretamente
        const policy = element?.quotation?.policy || element?.policy;
        const insurer = policy?.insurer;
        const insuranceCategory = element?.quotation?.insurance_category || policy?.insurance_category;

        return {
            id: element.id,
            number: policy?.number,
            policy_holder_name: policy?.policy_holder_name,
            insured_name: policy?.insured_name,
            policy_holder_document: policy?.policy_holder_document,
            insurance_type_id: insuranceCategory?.name,
            coverage_value: policy?.coverage_value,
            insurance_premium: policy?.insurance_premium,
            validity_start: policy?.validity_start ? this.formatDateLocal(policy.validity_start) : '-',
            validity_expiration: policy?.validity_expiration ? this.formatDateLocal(policy.validity_expiration) : '-',
            extended_date: element.extended_date ? this.formatDateLocal(element.extended_date) : '-',
            end_date: element.end_date ? this.formatDateLocal(element.end_date) : '-',
            status: element.status?.translate,
            icon_insurer: insurer?.icon,
            billet_url: policy?.billing_file,
        };
      });

      this.items = mappedItems;
    },
    changeDate(id) {
      this.loading = true;
      billetService
        .changeDate(id, { date: this.newDate })
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.$refs.modalProrrogar.hide();
          this.fetchBillets();
          this.showSuccess('Boleto prorrogado com sucesso.');
        })
        .catch(() => {
          this.showError("Não foi possível alterar data do boleto.");
        })
    },
    getEnumKeyByEnumValue(enumObject, value) {
      return Object.keys(enumObject).find(key => enumObject[key] === value);
    },
    openModalProrrogar(item) {
      this.newDate = null;
      this.selectedBillet = item;
      this.$refs.modalProrrogar.show();
    },
    openLinkTargetBlank(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style></style>
